import React from "react";
import { Globe2 } from "lucide-react";

import AM from "country-flag-icons/react/3x2/AM";
import BY from "country-flag-icons/react/3x2/BY";
import EU from "country-flag-icons/react/3x2/EU";
import KG from "country-flag-icons/react/3x2/KG";
import KZ from "country-flag-icons/react/3x2/KZ";
import PL from "country-flag-icons/react/3x2/PL";
import RU from "country-flag-icons/react/3x2/RU";
import UZ from "country-flag-icons/react/3x2/UZ";

import { jurisdictionTitle } from "@/utils/jurisdiction";
import { cn } from "@/utils";

/**
 * Флаг юрисдикции.
 *
 * Флаги берём из `country-flag-icons`: каждая страна — отдельный React-SVG,
 * в сборку попадают только перечисленные здесь. Эмодзи-флаги не годятся —
 * в Windows для них нет глифов, и вместо флага виден код страны; внешний CDN
 * с картинками не годится тем, что тянет посторонний запрос из кабинета.
 *
 * Для международных источников флага нет по существу — там глобус.
 */
const FLAGS: Readonly<Record<string, typeof RU>> = {
  rus: RU,
  kaz: KZ,
  blr: BY,
  kgz: KG,
  uzb: UZ,
  arm: AM,
  pol: PL,
  eu: EU,
};

interface JurisdictionFlagProps {
  code: string;
  className?: string;
}

export const JurisdictionFlag: React.FC<JurisdictionFlagProps> = ({ code, className }) => {
  const Flag = FLAGS[code];
  const title = jurisdictionTitle(code);

  if (!Flag) {
    return <Globe2 aria-label={title} className={cn("shrink-0", className)} />;
  }

  // Рамка: у флагов с белой полосой у края (Польша) её иначе не видно на
  // светлом фоне.
  return <Flag role="img" aria-label={title} className={cn("shrink-0 rounded-[1px] ring-1 ring-line", className)} />;
};

export default JurisdictionFlag;
